export default __webpack_public_path__ + "static/media/HEADACHE.4c28a5b6.png";